import React, {useEffect, useRef, useState} from "react";
import {checkNullArr, getArrLen} from "../../common/fusion-ui/utils/ReactUtils";

const AutoPlaySlider = React.memo(({
                                       items = [],
                                       justifyAt = 'center',
                                       alignAt = 'center',
                                       height = '140px',
                                       transitionMS = 1000,
                                       delayMS = 3500,
                                   }) => {
    const [currIndex, setCurrIndex] = useState(0);
    const timeoutRef = useRef(null);

    function resetTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    useEffect(() => {
        resetTimeout();
        timeoutRef.current = setTimeout(() =>
                setCurrIndex((prevIndex) =>
                    prevIndex === getArrLen(items) - 1 ? 0 : prevIndex + 1
                ),
            delayMS
        );

        return () => {
            resetTimeout();
        };
    }, [currIndex, getArrLen(items), delayMS]);

    return (
        <div className={""} style={{overflow: 'hidden', height}}>
            <div
                className={"d-flex"}
                style={{
                    transform: `translateX(${-currIndex * 100}%)`,
                    transition: `transform ${transitionMS}ms ease`,
                }}>
                {checkNullArr(items) && items.map((item, index) => (
                    <div
                        className={`d-flex jc-${justifyAt} al-${alignAt}`}
                        key={index}
                        style={{flex: '0 0 100%', height}}>
                        {item}
                    </div>
                ))}
            </div>

            <div className={`text-center mt-1 `}>
                {items.map((_, index) => (
                    <div
                        key={index}
                        className={`slideshowDot d-inline-block circular cursor-pointer ms-1 ${currIndex === index ? "active" : ""}`}
                        style={{width: '15px', height: '15px'}}
                        onClick={() => {
                            setCurrIndex(index);
                        }}
                    ></div>
                ))}
            </div>
        </div>
    );
});

export default AutoPlaySlider;
